import { CustomWindow } from './models/customwindow';

declare let window: CustomWindow;

export class General {
  constructor() {}

  static loadImage(imageElement: HTMLImageElement): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      imageElement.onload = () => {
        resolve(imageElement);
      };

      if (imageElement.complete) {
        resolve(imageElement);
      }

      imageElement.onerror = reject;
    });
  }
}

window.addEventListener('CookiebotOnLoad', () => {
  if (!document.body.classList.contains("cookiebot-loaded")) {
    document.body.classList.add("cookiebot-loaded");
  }
});